import { HTTPServiceClient } from '@/packages/http/service';
import * as endpoint from './endpoints';
import {
  UserRequest,
  DeleteUserRequest,
  Role,
  OrgUsersRequest,
  PaginatedResult,
  ClientPaginatedResult,
  OrgPensionSchemeRequest,
  OrgUserStatistics
} from './types';
/**
 * --------------------------------------------------
 *	User HTTP Serice
 * --------------------------------------------------
 **/
export const UserService = {
  async getOrganizationUsers(
    orgUsersRequest: OrgUsersRequest
  ): Promise<PaginatedResult> {
    const { data } = await HTTPServiceClient.get(
      endpoint.GET_ORGANISATION_USERS(
        orgUsersRequest.orgId,
        orgUsersRequest.page,
        orgUsersRequest.limit,
        orgUsersRequest.searchKeyword
      )
    );
    return data;
  },
  async getOrganizationClients(
    params: OrgPensionSchemeRequest
  ): Promise<ClientPaginatedResult> {
    const { data } = await HTTPServiceClient.get(
      endpoint.GET_ORGANIZATION_CLIENTS(params)
    );
    return data;
  },
  async postOrganizationUser(userRequest: UserRequest): Promise<Response> {
    const { data } = await HTTPServiceClient.post(
      endpoint.POST_ORGANIZATION_USER(userRequest.orgId),
      userRequest
    );
    return data;
  },
  async deleteOrganizationUser(
    deleteUserRequest: DeleteUserRequest
  ): Promise<Response> {
    const { data } = await HTTPServiceClient.delete(
      endpoint.DELETE_ORGANIZATION_USER(
        deleteUserRequest.orgId,
        deleteUserRequest.userId
      )
    );
    return data;
  },
  async putOrganizationUser(userRequest: UserRequest): Promise<Response> {
    const { data } = await HTTPServiceClient.put(
      endpoint.PUT_ORGANIZATION_USER(userRequest.orgId, userRequest.userId),
      userRequest
    );
    return data;
  },
  async getRoles(): Promise<Role[]> {
    const { data } = await HTTPServiceClient.get(endpoint.GET_ROLES);
    return data.data;
  },
  async getOrgUserStatistics(
    orgId: string,
    userId: string
  ): Promise<OrgUserStatistics> {
    const { data } = await HTTPServiceClient.get(
      endpoint.GET_ORG_USER_STATISTICS(orgId, userId)
    );
    return data?.data;
  }
};
